import styled from 'styled-components';

import type {WithThemeProp} from '../../../styles';
import type {StyledProps} from './types';

import {getColor, msi} from '../../../styles';
import {LoadingSpinner} from '../../LoadingSpinner';
import {View} from '../../View';

type SpinnerStyledProps = Pick<
  StyledProps,
  'accentColor' | 'disabled' | 'scheme' | 'variant'
> & {
  buttonSize: StyledProps['size'];
  isSingle: boolean;
};

const getSchemeColor =
  (
    scheme: SpinnerStyledProps['scheme'],
    accentColor: SpinnerStyledProps['accentColor'],
  ) =>
  <ComponentProps extends WithThemeProp>(p: ComponentProps) => {
    if (accentColor) {
      return getColor(accentColor)(p);
    }

    switch (scheme) {
      case 'attention':
        return getColor('icon.red')(p);
      case 'primary':
      case 'secondary':
        return getColor(`icon.${scheme}`)(p);
      default:
        return getColor('icon.gray')(p);
    }
  };

const getFillColor = (p: SpinnerStyledProps & WithThemeProp) => {
  if (p.disabled) {
    if (p.variant === 'primary') {
      return getColor('icon.white')(p);
    }

    return getSchemeColor(p.scheme, p.accentColor)(p);
  }

  switch (p.variant) {
    case 'primary':
      return getColor('icon.white')(p);
    default:
      return getSchemeColor(p.scheme, p.accentColor)(p);
  }
};

const getSize = (size: SpinnerStyledProps['buttonSize'], isSingle = false) => {
  let result = 20;

  switch (size) {
    case 'la':
      result = 24;
      break;
    case 'sm':
      result = 16;
      break;
    default:
      result = 20;
  }

  if (isSingle) {
    return result + 6;
  }

  return msi(result);
};

export const ButtonSpinner = styled(LoadingSpinner).attrs<SpinnerStyledProps>(
  p => ({
    size: getSize(p.buttonSize, p.isSingle),
    strokeInnerColor: getFillColor(p),
    strokeOuterColor: getFillColor(p),
  }),
)<SpinnerStyledProps>``;

export const ButtonSpinnerContainer = styled(View)`
  align-items: center;
  justify-content: center;
  flex: 1;
  position: absolute;
  inset: 0;
`;
